(ns rothko.theme.manatee.audio.wave-player
  (:refer-clojure :exclude [rem])
  (:require [garden.color :refer [as-hex lighten]]
            [garden.units :refer [px rem s]]
            #?(:clj [garden.def :refer [defkeyframes]])
            [rothko.theme.manatee.colours :refer [colours]])
  #?(:cljs (:require-macros [garden.def :refer [defkeyframes]])))

(defkeyframes progress-stripes
  [:to
   {:background-position "-100px 0px"}])

(defn striped-gradient
  [progress-colour]
  (str "linear-gradient(-45deg, "
       "transparent 33%, "
       progress-colour " 33%, "
       progress-colour " 66%, "
       "transparent 66%)"))

(defn backward-striped-gradient
  [progress-colour]
  (str "linear-gradient(45deg, "
       "transparent 33%, "
       progress-colour " 33%, "
       progress-colour " 66%, "
       "transparent 66%)"))

(def progress-bar
  {:primary
   {:animation-name progress-stripes
    :animation-duration (s 1.5)
    :animation-iteration-count :infinite
    :animation-timing-function :linear
    :appearance :none
    :background-image (striped-gradient (as-hex (:blue-dark colours)))
    :background-size [[(px 50) (px 20)] ["100%" "100%"] ["100%" "100%"]]
    :height (rem 0.5)}

   :secondary
   {:animation-name progress-stripes
    :animation-duration (s 0.5)
    :animation-iteration-count :infinite
    :animation-timing-function :quadratic
    :appearance :none
    :background-image (backward-striped-gradient (as-hex (:blue-dark colours)))
    :background-size [[(px 50) (px 20)] ["100%" "100%"] ["100%" "100%"]]
    :height (rem 1)}
   })

(def controls
  {:primary
   {:icon-colour (:blue-dark colours)}

   :diarisation
   {:icon-margin 0}

   :secondary
   {:icon-colour (:purple colours)}})

(def titles
  {:primary
   {:titles-min-width 0
    :prefix-text-colour (:grey-dark colours)}

   :secondary
   {:titles-min-width 0
    :prefix-text-colour (:grey-dark colours)}

   :no-title-prefix
   {:titles-min-width 0
    :titles-display :flex
    :titles-justify-content :flex-end
    :titles-flex-direction :column}})

(def wave-player
  {:primary
   {:cursor-colour (as-hex (:blue-dark colours))
    :height 75
    :progress-peaks-colour (as-hex (:green colours))
    :wave-peaks-colour (as-hex (lighten (:green colours) 50))}

   :diarisation
   {:wave-peaks-colour (as-hex (:green colours))
    :height 92
    :cursor-colour (:red-bright colours)}

   :secondary
   {:cursor-colour (as-hex (:blue-light colours))
    :height 75
    :progress-peaks-colour (as-hex (:blue-dark colours))
    :wave-peaks-colour (as-hex (lighten (:blue-dark colours) 30))}})
